




































































































import {Component, Vue} from 'vue-property-decorator';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import SenderSelector from '@/components/user/SenderSelector.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';

import moment from 'moment';

import api from '@/infrastructure/api/api';

import YearPicker from '@/components/datepicker/YearPicker.vue';
import YearMonthPicker from '@/components/datepicker/YearMonthPicker.vue';
import deliveryWeightedApi from '@/infrastructure/api/custom/teishinkai/deliveryWeightedApi';
import {納品加重明細出力条件型} from '@/type/custom/teishinkai/納品加重明細出力条件';
import 納品加重明細出力条件チェッカー from '@/type/custom/teishinkai/validator/納品加重明細出力条件チェッカー';
import {卸型} from '@/type/wholesale/wholesale';

@Component({
  components: {
    YearPicker,
    YearMonthPicker,
    NormalButton,
    ConfirmDialog,
    DepartmentSelector,
    Datepicker,
    ButtonPanel,
    IconButton,
    SenderSelector,
    AlertDialog,
  },
  filters: {
    日付のフォーマット(date: Date): string | null {
      if (!date) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class AggregateWithdraw extends Vue {
  // data
  卸一覧: 卸型[] = [];

  出力条件: 納品加重明細出力条件型 = {
    対象期間区分: '対象年度',
    対象年度: this.年度(),
    対象年月: '',
    卸コード: '',
    薬価有無: '薬価あり',
    出力順: 'カナ名',
    出力条件: '指定なし',
  };

  アラートメッセージ: string[] | string | null = null;

  checker: 納品加重明細出力条件チェッカー | null = null;

  納品加重明細表出力確認ダイアログを開く(): void {
    this.checker = new 納品加重明細出力条件チェッカー(this.出力条件);
    if (this.checker.hasErrors()) {
      this.alert(this.checker.errorMessages());
      return;
    }
    this.ダイアログを開く('納品加重明細表出力確認ダイアログ');
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  // methods
  納品加重明細表をダウンロードする() {
    deliveryWeightedApi.集計ファイルをダウンロードする(this.出力条件)
      .catch((error: any) => {
        if (!error.data.errors) {
          this.alert(error.data.message);
        }
        if (error.data.errors) {
          this.alert(error.data.errors);
        }
      });
    this.ダイアログを閉じる('納品加重明細表出力確認ダイアログ');
  }

  年度(): string {
    const today = new Date();
    if ((today.getMonth() + 1) <= 3) {
      return String(today.getFullYear() - 1);
    } else {
      return String(today.getFullYear());
    }
  }

  出力条件入力エラー判定(項目名: string): boolean {
    if (this.checker == null) return false;
    return this.checker.hasError(項目名);
  }

  alert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('納品加重明細表アラート');
  }

  // lifecycle hooks
  async created(): Promise<void> {
    this.卸一覧 = await api.卸一覧を取得する()
      .catch((error: any) => {
        this.alert(error.data.message);
        return [];
      });
  }
}
